var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.click}},[_c('i',{staticClass:"el-icon-mic"}),_vm._v(" "+_vm._s(_vm.episodeTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }